import { httpServer as http } from "@/lib/axios";
import { httpServer as downFilehttp } from "@/lib/downFileAxios";

export default {
  namespaced: true,
  state: {},
  mutations: {},
  actions: {
    // 列表
    async bonusPaging({ rootState }, params = {}) {
      const data = await http(
        "/k1/rewardTradeBill/bonusPaging",
        params
      );
      return data.data || { list: [], total: 0 };
    },
    // 奖励涉及胎号明细
    async rewardTradeBill({ rootState }, params = {}) {
      const data = await http(
        "/k1/rewardTradeBill/item",
        params
      );
      return data.data || {};
    },
    // 导出
    async bonusExport({ rootState }, params = {}) {
      const data: any = await downFilehttp({
        url: "/k1/rewardTradeBill/bonusExport",
        params
      });

      return data;
    },
    // 门店下拉列表
    async storeSimplePaging({ rootState }, params: any = {}) {
      const { searchKey = "", pageInput: { pageNum = 1, pageSize = 10 } = {} } =
        params || {};

      const data = await http(
        "/store/simplePaging",
        {
          storeNameLike: searchKey,

          pageSize,
          pageNum,
        }
      );
      console.log(data, '--storeSimplePaging')
      return data.data || { list: [], total: 0 }
    },
    // 发送验证码
    async sendSms({ rootState }, params = {}) {
      const data = await http(
        "/k1/shop-info/sendSms",
        params
      );

    }
  }
};
